<template>
    <div>
        <template>
            <div class="table">
                <table class="table" id="complaintTable" width="100%">
                    <thead>
                    <tr>
                        <th>Ticket No</th>
                        <th>Subject</th>
                        <th>Priority</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div aria-hidden="true" aria-labelledby="newBatchModalLabel" class="modal fade" id="newBatchModal"
                 role="dialog"
                 tabindex="-1">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="modal-body new-batch-popup">
                            <div class="popup-head line-head mt-4 mb-3">
                                <h2 class="pb-3">View Ticket Detail </h2>
                            </div>
                            <div class="container">
                                <div class="row  ">
                                    <div class="col-lg-12 col-md-12 col-sm-12  d-flex p-0">
                                        <div class="col-lg-6 col-md-6 col-sm-12  mt-2  p-0">
                                            <div class="card" style="padding: 8px; box-shadow: none; height: 100%">
                                                <div class="mb-3" style="border-bottom: 1px dashed #dee2e6;">
                                                    <h3 class="mb-2">Full Name :</h3>
                                                    <p class="mb-3">{{this.full_name}}</p>
                                                </div>
                                                <div class="mb-3" style="border-bottom: 1px dashed #dee2e6;">
                                                    <h3 class="mb-2">Subject :</h3>
                                                    <p class="mb-3">{{this.subject}}</p>
                                                </div>
                                                <div class="mb-3">
                                                    <h2 class="mb-2">Message :</h2>
                                                    <textarea class="form-control" disabled rows="5"
                                                              style="resize: none;border: #c3c7d1fa dashed 1px;"> {{this.message}}</textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12  mt-2 ">
                                            <h3>Ticket Log</h3>
                                            <ul class="timeline">
                                                <li>
                                                    <h5>priority</h5>
                                                    <a class="float-right" href="#">{{this.ticketUpdatedDate}}</a>
                                                    <p>{{this.ticketpriority}}</p>
                                                </li>
                                                <li>
                                                    <h5>status</h5>
                                                    <a class="float-right" href="#">{{this.ticketUpdatedDate}}</a>
                                                    <p>{{this.ticketStatus}}</p>
                                                </li>
                                                <li>
                                                    <h5>purpose</h5>
                                                    <a class="float-right" href="#">{{this.ticketUpdatedDate}}</a>
                                                    <p>{{this.TicketPurpose}}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    var dtTable = null;
    export default {
        props: {
            complaintSubmitted: Boolean,
        },
        data() {
            return {
                updated_at: '',
                created_at: '',
                priority: '',
                status: '',
                full_name: '',
                subject: "",
                message: "",
                ticketpriority: "",
                ticketStatus: "",
                TicketPurpose: "",
                ticketUpdatedDate: '',
                companyData: null,
            };
        },
        watch: {
            complaintSubmitted: {
                handler: function (newVal) {
                    if (newVal) {
                        $('#complaintTable').DataTable().ajax.reload();
                    }
                },
                deep: true,
            },
        },
        mounted() {
            this.$Progress.start();
            this.getComplaintHistory();
            $('#complaintTable').on('click', '.view-complaint', this.handleViewComplaint);
        },
        methods: {
            filterTable() {
                this.$Progress.start();
                this.dtTable.draw();
                this.$Progress.finish();
            },
            getComplaintHistory: function () {
                var that = this;
                that.dtTable = $('#complaintTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom: '<"row pb-3 view-filter"<"col-md-12 pr-4 pl-4 text-right"f>><"table-holder mb-3"t><"row mb-3 view-pager"<"col-sm-4 pl-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 pr-4 text-right"l>>r',
                    ajax: {
                        "url": "api/allEnquiry",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": function (json) {
                            if (json && json.records) {
                                return json.records;
                            } else {
                                return [];
                            }
                        },
                        "error": function(xhr, errorType, exception) {
                            that.$Progress.fail(); // Handle AJAX error
                        },
                        "complete": function () {
                            that.$Progress.finish(); // Finish progress regardless of success or failure
                        }
                    },
                    columns: [
                        {
                            data: 'id',
                            sorting: false,
                            render: function (data, type, full) {
                                return '<p data-complaint-id="' + full.id + '" data-placement="top" title="" class=" view" data-original-title="View" style="color: rgb(115, 103, 240);">TKT_' + full.id + '</p>';
                            }
                        },
                        {data: 'customer_details'},
                        {
                            data: 'priority',
                            render: function (data, type, full) {
                                return '<span class="badge badge-pill badge-primary">' + full.priority + '</span>';
                            }
                        },
                        {
                            data: 'created_at',
                            render: function (data, type, full) {
                                return moment(full.created_at).format('YYYY-MM-DD hh:mm A');
                            }
                        },
                        {
                            data: 'updated_at',
                            render: function (data, type, full) {
                                return moment(full.updated_at).format('YYYY-MM-DD hh:mm A');
                            }
                        },
                        {
                            data: 'status',
                            render: function (data, type, full) {
                                return '<span class="badge badge-pill badge-secondary">' + full.status + '</span>';
                            }
                        },
                        {
                            data: 'id',
                            sorting: false,
                            render: function (data, type, full) {
                                return '<p data-complaint-id="' + full.id + '" class="btn btn-primary view-complaint" title="View"><i class="fas fa-eye"></i></p>';
                            }
                        }
                    ],
                    "order": [[0, "desc"]],
                });
                this.complaintSubmitted = false;
            },

            handleViewComplaint(event) {
                const complaintId = $(event.currentTarget).data('complaint-id');
                $('#newBatchModal').modal('show');
                this.getsingleComplaintrecord(complaintId);
            },
            getsingleComplaintrecord(id) {
                axios.get('/api/viewEnquiry/' + id)
                    .then(res => {
                        this.full_name = res.data.fullname,
                            this.subject = res.data.customer_details,
                            this.message = res.data.message,
                            this.ticketpriority = res.data.priority,
                            this.ticketStatus = res.data.status,
                            this.TicketPurpose = res.data.purpose,
                            this.ticketUpdatedDate = moment(res.data.updated_at).format('YYYY-MM-DD');
                        this.$Progress.finish();
                    }).then(res => {
                    $('.selectpicker').selectpicker();
                }).catch(err => {
                    console.log(err);
                });
            },
        },
    }
</script>
<style>
    .badge-primary {
        color: #28c76f !important;
        background-color: rgba(40, 199, 111, .12) !important;
        padding: 12px;
        border-radius: 10px;
    }

    .badge-secondary {
        color: #00cfe8;
        background-color: rgba(0, 207, 232, .12);
        padding: 12px;
        border-radius: 10px;
    }

    ul.timeline {
        list-style-type: none;
        position: relative;
    }

    ul.timeline:before {
        content: ' ';
        background: #d4d9df;
        display: inline-block;
        position: absolute;
        left: 2px;
        width: 2px;
        height: 100%;
        z-index: 400;
    }

    ul.timeline > li {
        margin: 20px 0;
        padding-left: 20px;
    }

    ul.timeline > li:before {
        content: ' ';
        background: white;
        display: inline-block;
        position: absolute;
        border-radius: 50%;
        border: 5px solid #eb401f;
        left: -7px;
        width: 20px;
        height: 20px;
        z-index: 400;
    }

    h5 {
        text-decoration: none;
        color: #eb401f;
    }

    .form-control:disabled, .form-control[readonly] {
        background: none;
        opacity: 1;
    }

    .timeline li p {
        height: 65px;
        overflow: hidden;
    }

</style>
